const recommendedProducts = [
  {
    id: 7,
    name: "Vintage Round Frames",
    price: 95,
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 8,
    name: "Contemporary Square Glasses",
    price: 140,
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 9,
    name: "Pilot Style Sunglasses",
    price: 165,
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 10,
    name: "Elegant Cat Eye Frames",
    price: 125,
    image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 11,
    name: "Sleek Metal Rim Glasses",
    price: 105,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: 12,
    name: "Adventure Sports Glasses",
    price: 175,
    image: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?auto=format&fit=crop&w=400&q=80",
  },
];

export default recommendedProducts; 